/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeavePolicyCommand
 */
export interface CreateLeavePolicyCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateLeavePolicyCommand
     */
    name?: string;
}

/**
 * Check if a given object implements the CreateLeavePolicyCommand interface.
 */
export function instanceOfCreateLeavePolicyCommand(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateLeavePolicyCommandFromJSON(json: any): CreateLeavePolicyCommand {
    return CreateLeavePolicyCommandFromJSONTyped(json, false);
}

export function CreateLeavePolicyCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeavePolicyCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CreateLeavePolicyCommandToJSON(value?: CreateLeavePolicyCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

